import styled from "styled-components";
import {Button} from "antd";

export const StyledPayoutDetailsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  font-size: 1.4rem;

  .bold-text {
    font-size: 1.4rem;
    font-weight: 600;
  }
`;

export const StyledTextButton = styled(Button)`
  padding: 0;
  height: auto;

  .text-underline {
    text-decoration: underline;
  }
`;
export const StyledOtpInput = styled.input`
  width: 4rem !important;
  height: 4rem !important;
  border-radius: 2px;
  border: 1px solid #d9d9d9;

  @media (max-width: 375px) {
    width: 3rem !important;
    height: 3rem !important;
  }
`;
